<template>
    <select v-if='languages.length > 0' @change="changeLanguage($event.target.value)" :value="this.$translate.current">
        <option v-for="(option, index) in languages" :value="option.value" :key="index">{{option.name}}</option>
    </select>
</template>
<script>

export default {
    name: 'Footer',

    data() {
        return {
            languages: [
                // hide all languages for now, because the application should be used in english only for now
                // { value: 'nl_NL', name: this.$translate.text('locales.dutch') },
                // { value: 'en_EN', name: this.$translate.text('locales.english') },
                // { value: 'de_DE', name: this.$translate.text('locales.german') },
            ],
        };
    },

    methods: {
        changeLanguage(event) {
            this.$translate.current = event;
        },
    },
};
</script>
<style lang="scss" scoped>
</style>
